<!--
SPDX-FileCopyrightText: 2023 Marlon W (Mawoka)
SPDX-FileCopyrightText: 2026 Max Booth

SPDX-License-Identifier: MPL-2.0
-->

<script lang="ts">
	import LanguageToggle from './language-toggle.svelte';
	import { getLocalization } from '$lib/i18n';
	import { site_name } from '$lib/config';
	import Logo from '$lib/components/logo.svelte';

	const { t } = getLocalization();
	const year = new Date().getFullYear();
</script>

<footer class="w-full bg-[#161331] text-slate-300 mt-auto">
	<div class="max-w-6xl mx-auto px-6 py-10 grid gap-8 md:grid-cols-3">
		<div>
			<a href="/" class="flex items-center gap-2 text-white">
				<Logo class="w-8 h-8" />
				<span class="font-display text-lg font-semibold">{site_name}</span>
			</a>
			<p class="mt-3 text-sm text-slate-400 max-w-xs">
				Live classroom quizzes: create, share a PIN and play together on any device.
			</p>
		</div>
		<nav class="grid grid-cols-2 gap-2 text-sm" aria-label="Footer">
			<a class="hover:text-white transition" href="/play">{$t('words.play')}</a>
			<a class="hover:text-white transition" href="/explore">{$t('words.explore')}</a>
			<a class="hover:text-white transition" href="/search">{$t('words.search')}</a>
			<a class="hover:text-white transition" href="/docs">{$t('words.docs')}</a>
			<a class="hover:text-white transition" href="/dashboard">{$t('words.dashboard')}</a>
			<a class="hover:text-white transition" href="/docs/attribution">Credits</a>
		</nav>
		<div class="md:justify-self-end">
			<LanguageToggle />
		</div>
	</div>
	<div class="border-t border-white/10">
		<p class="max-w-6xl mx-auto px-6 py-4 text-xs text-slate-400 text-center md:text-left">
			&copy; {year} {site_name} &middot; Built on
			<a
				class="underline hover:text-white"
				href="https://github.com/mawoka-myblock/ClassQuiz"
				target="_blank"
				rel="noopener">ClassQuiz</a
			>
			by Mawoka, open source under the MPL-2.0.
		</p>
	</div>
</footer>
